function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M59.4788 26.2478C59.4788 18.4074 65.4267 12.6398 73.5374 12.6398C77.4126 12.6398 80.9272 13.9014 83.3604 16.5149L81.5581 18.3173C79.3952 16.0643 76.6916 15.1631 73.6275 15.1631C67.1389 15.1631 62.2725 19.9394 62.2725 26.2478C62.2725 32.6463 67.1389 37.3325 73.6275 37.3325C76.6916 37.3325 79.3952 36.3412 81.5581 34.0882L83.3604 35.8906C81.0173 38.5041 77.5027 39.8558 73.5374 39.8558C65.5168 39.8558 59.4788 34.0882 59.4788 26.2478Z",
  fill: "#58595B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M86.5146 26.2478C86.5146 18.4074 92.4625 12.6398 100.663 12.6398C108.684 12.6398 114.722 18.4074 114.722 26.2478C114.722 34.0882 108.684 39.8558 100.663 39.8558C92.4625 39.8558 86.5146 34.0882 86.5146 26.2478ZM111.838 26.2478C111.838 19.8493 107.062 15.1631 100.573 15.1631C94.0847 15.1631 89.3083 19.8493 89.3083 26.2478C89.3083 32.6463 94.1748 37.3325 100.573 37.3325C107.062 37.3325 111.838 32.6463 111.838 26.2478Z",
  fill: "#58595B"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M142.479 12.82L130.583 39.6756H127.789L115.894 12.82H118.958L129.231 36.1609L139.595 12.82H142.479Z",
  fill: "#58595B"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M146.354 12.82H149.148V39.6756H146.354V12.82Z",
  fill: "#58595B"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M157.979 12.82H168.884C177.445 12.82 183.213 18.3173 183.213 26.2478C183.213 34.1783 177.445 39.6756 168.884 39.6756H157.979V12.82ZM168.704 37.2423C175.823 37.2423 180.419 32.7364 180.419 26.2478C180.419 19.8493 175.823 15.2532 168.704 15.2532H160.773V37.1522H168.704V37.2423Z",
  fill: "#58595B"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M58.5776 68.9645L60.6503 64.2783C62.9033 65.9005 66.3279 67.072 69.482 67.072C73.1769 67.072 74.6189 65.8103 74.6189 64.1882C74.6189 59.1415 59.0282 62.6562 59.0282 52.6529C59.0282 48.0568 62.7231 44.2718 70.2931 44.2718C73.6275 44.2718 77.1422 45.0829 79.5754 46.6149L77.6829 51.3011C75.1596 49.8592 72.6362 49.2284 70.2931 49.2284C66.5982 49.2284 65.1563 50.5801 65.1563 52.2924C65.1563 57.249 80.747 53.8244 80.747 63.6475C80.747 68.1534 77.0521 71.9385 69.3919 71.9385C65.2464 72.0286 60.9207 70.7669 58.5776 68.9645Z",
  fill: "#58595B"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M104.989 66.6213V71.5779H84.2616V44.8124H104.539V49.769H90.3898V55.6267H102.826V60.4932H90.3898V66.7114H104.989V66.6213Z",
  fill: "#58595B"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M133.557 44.8124V71.5779H128.42L115.082 55.2662V71.5779H108.954V44.8124H114.091L127.429 61.124V44.8124H133.557Z",
  fill: "#58595B"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M144.461 49.8591H135.9V44.8124H159.241V49.8591H150.68V71.5779H144.461V49.8591Z",
  fill: "#58595B"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M161.674 44.8124H167.892V71.5779H161.674V44.8124Z",
  fill: "#58595B"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M197.902 44.8124V71.5779H192.765L179.428 55.2662V71.5779H173.3V44.8124H178.436L191.774 61.124V44.8124H197.902Z",
  fill: "#58595B"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M224.037 66.6213V71.5779H203.219V44.8124H223.496V49.769H209.347V55.6267H221.784V60.4932H209.347V66.7114H224.037V66.6213Z",
  fill: "#58595B"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M228.002 44.8124H234.22V66.6213H247.648V71.5779H228.002V44.8124Z",
  fill: "#58595B"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M29.7394 32.5559V52.1118C29.7394 61.4843 22.1694 69.0543 12.797 69.0543H9.73289C17.3029 78.0662 28.7481 83.8339 41.4549 83.8339V22.823H39.4723C34.0651 22.823 29.7394 27.1488 29.7394 32.5559Z",
  fill: "#205A9D"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5299 52.1119V32.556C22.5299 23.1836 30.0999 15.6136 39.4723 15.6136H41.4549V0.833984C18.5646 0.833984 0 19.3986 0 42.2889C0 49.3182 1.80239 55.9871 4.86645 61.8448H12.797C18.114 61.8448 22.5299 57.5191 22.5299 52.1119Z",
  fill: "#205A9D"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M39.4722 15.6135C30.0998 15.6135 22.5297 23.1835 22.5297 32.556V52.1119C22.5297 57.519 18.204 61.8448 12.7968 61.8448H4.86632C6.21811 64.4582 7.93038 66.8013 9.73277 69.0543H12.7968C22.1693 69.0543 29.7393 61.4843 29.7393 52.1119V32.556C29.7393 27.1488 34.065 22.8231 39.4722 22.8231H41.4548V15.6135H39.4722Z",
  fill: "white"
});

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 84,
    viewBox: "0 0 248 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bd2fa38f.svg";
export { ForwardRef as ReactComponent };